import { httpRequest } from './httpClient'

export const listCategories = () =>
  httpRequest('/api/export/categories', { method: 'GET' })

export const analyzeAttributes = (category, images, title, fabric) =>
  httpRequest('/api/export/analyze-attributes', {
    method: 'POST',
    body: { category, images, title, fabric }
  })

export const buildPack = (sku, productJson, images) =>
  httpRequest('/api/export/build-pack', {
    method: 'POST',
    body: { sku, productJson, images },
    responseType: 'blob'
  })
